import { AlertTriangle, CreditCard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/providers/AuthProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const SubscriptionGracePeriodBanner = () => {
	const { subscriptionIssue, isInGracePeriod, isSuperAdmin, isAdmin } = useAuth();
	const { t } = useTranslation();
	const location = useLocation();
	const navigate = useNavigate();

	// Only show to org admins, never to super admins or on admin pages
	if (isSuperAdmin || !isAdmin) return null;
	if (location.pathname.startsWith("/admin")) return null;

	if (!isInGracePeriod) return null;

	const issueKey = subscriptionIssue && ["payment_overdue", "payment_method_invalid", "subscription_canceled"].includes(subscriptionIssue)
		? subscriptionIssue
		: "default";

	const description = t(`billing.gracePeriodBanner.${issueKey}`);

	return (
		<div className="w-full bg-amber-50 border border-amber-200 rounded-sm p-3 mt-3">
			<div className="flex items-center justify-between gap-4">
				<div className="flex items-center gap-2 min-w-0">
					<AlertTriangle className="h-4 w-4 text-amber-600 shrink-0" />
					<div className="flex items-center gap-2 min-w-0">
						<p className="text-xs font-medium text-amber-900">
							{t("billing.gracePeriodBanner.title")}
						</p>
						<span className="text-xs text-amber-700 truncate">
							{description}
						</span>
					</div>
				</div>
				<div className="flex items-center gap-2 shrink-0">
					<Button
						size="sm"
						variant="outline"
						onClick={() => navigate("/admin?page=billing")}
						className="flex items-center gap-1 text-xs h-7 px-2 border-amber-300 text-amber-700 hover:bg-amber-100"
					>
						<CreditCard className="h-3 w-3" />
						{t("billing.goToBilling")}
					</Button>
					<Button
						size="sm"
						variant="outline"
						onClick={() => window.location.href = "mailto:billing@digger.be"}
						className="flex items-center gap-1 text-xs h-7 px-2 border-amber-300 text-amber-700 hover:bg-amber-100"
					>
						{t("billing.contactUs")}
					</Button>
				</div>
			</div>
		</div>
	);
};
